import React from "react";

function Images() {
  return <div></div>;
}

export default Images;
